import { RouteRecordRaw } from 'vue-router';

export const benchmarksRoutes: Record<string, RouteRecordRaw> = {
    redirect: {
        path: '',
        name: 'benchmarksRedirect',
        redirect: { name: 'Index' },
        meta: {
            headName: 'Benchmarks Redirect',
        },
    },
    index: {
        path: 'index',
        name: 'Index',
        components: {
            default: () => import('@/views/powerMarkets/benchmarks/IndexView.vue'),
        },
        meta: {
            headName: 'Index',
            accessName: 'index',
            searchMeta: {
                tags: ['battery', 'storage', 'BESS', 'indices', 'leaderboard'],
            },
        },
    },
    leaderboard: {
        path: 'leaderboard',
        name: 'Leaderboard',
        components: {
            default: () => import('@/views/powerMarkets/benchmarks/LeaderboardView.vue'),
        },
        meta: {
            headName: 'Leaderboard',
            videoLink: 'https://player.vimeo.com/video/508408080',
            accessName: 'leaderboard',
            searchMeta: {
                tags: ['battery', 'storage', 'BESS', 'indices', 'leaderboard'],
            },
        },
    },
    carbon: {
        path: 'bess-carbon',
        name: 'Carbon',
        components: {
            default: () => import('@/views/powerMarkets/benchmarks/CarbonCalculator.vue'),
        },
        meta: {
            headName: 'BESS Carbon',
            accessName: 'bess-carbon-emissions-calculator',
            searchMeta: {
                tags: ['battery', 'storage', 'BESS'],
            },
        },
    },
};
